module.exports = __webpack_public_path__ + "static/media/PlayStore1.0ac669ca.webp";